<template>
  <v-container fluid grid-list-md py1 class="substatus">
    <v-layout row wrap>
      <v-flex md12>
        <data-table ref="subStatusTable" @editRow="load" @auditRow="audit" />
      </v-flex>
    </v-layout>

    <v-layout row wrap class="mb-5">
      <v-flex md12>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.operativos.substatus.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
                  <v-layout row wrap>
                    <!-- Clave -->
                    <v-flex v-if="substatus.clave" md2><v-text-field v-model="substatus.clave" :label="$t('view.commons.clave')" disabled /></v-flex>

                    <!-- Code -->
                    <v-flex md2 class="mr-15">
                      <v-text-field
                        v-if="!view.action.submit.busy"
                        v-model="$v.substatus.code.$model"
                        :label="$t('view.operativos.substatus.form.code.label')"
                        :error-messages="getFirstErrorDescription($v.substatus.code)" />
                    </v-flex>

                    <!-- Payfac -->
                    <v-flex md3 lg2 xl1>
                      <v-switch
                        v-model="substatus.payfac"
                        input-value="true"
                        color="primary"
                        :label="$t('view.operativos.substatus.form.payfac.label')"
                        :disabled="substatus.gaps || view.action.submit.busy"
                        @change="substatus.canalaceptacion = null" />
                    </v-flex>

                    <!-- Gaps -->
                    <v-flex md3 lg2 xl1>
                      <v-switch
                        v-model="substatus.gaps"
                        input-value="true"
                        color="primary"
                        :label="$t('view.operativos.substatus.form.gaps.label')"
                        :disabled="substatus.payfac || view.action.submit.busy" />
                    </v-flex>
                  </v-layout>
                  <!-- ===================================================================================== -->
                  <v-layout row wrap>
                    <!-- Sub Estatus Vacio -->
                    <v-flex xs5 sm4 md2>
                      <v-switch v-model="$v.substatus.vacio.$model" input-value="true" color="primary" :label="$t('view.operativos.substatus.form.vacio.label')" :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Descripcion -->
                    <v-flex xs7 sm8 md10>
                      <v-text-field
                        v-model.trim="$v.substatus.descripcion.$model"
                        :prefix="substatus.vacio ? $t('view.operativos.substatus.vacio') + ' ' : ''"
                        :class="substatus.vacio ? 'prefix_vacio' : ''"
                        :label="$t('view.operativos.substatus.form.descripcion.label')"
                        :error-messages="getFirstErrorDescription($v.substatus.descripcion)"
                        maxlength="50"
                        :disabled="view.action.submit.busy"
                        onkeypress="return /^[a-zA-Z0-9\r\.\+\-\_\ ]+$/.test(event.key);" />
                    </v-flex>
                  </v-layout>
                  <!-- ===================================================================================== -->
                  <v-layout row wrap>
                    <!-- Accion -->
                    <v-flex>
                      <v-autocomplete
                        v-model.trim="$v.substatus.accion.$model"
                        :label="$t('view.operativos.substatus.form.accion.label')"
                        :error-messages="getFirstErrorDescription($v.substatus.accion)"
                        :items="view.elem.select.accion.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        return-object
                        deletable-chips
                        clearable
                        multiple
                        small-chips
                        :no-data-text="$t('view.commons.nodata')"
                        @input="search = ''" />
                    </v-flex>
                  </v-layout>
                  <!-- ===================================================================================== -->
                  <v-layout row wrap>
                    <!-- Status Pre Contacto -->
                    <v-flex>
                      <v-autocomplete
                        v-model.trim="$v.substatus.statusprecontacto.$model"
                        :label="$t('view.operativos.substatus.form.statusprecontacto.label')"
                        :error-messages="getFirstErrorDescription($v.substatus.statusprecontacto)"
                        :items="view.elem.select.statusprecontacto.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        return-object
                        deletable-chips
                        clearable
                        multiple
                        small-chips
                        :no-data-text="$t('view.commons.nodata')"
                        @input="search = ''" />
                    </v-flex>
                  </v-layout>
                  <!-- ===================================================================================== -->
                  <v-layout row wrap>
                    <!-- Post Test -->
                    <v-flex>
                      <v-autocomplete
                        v-model.trim="$v.substatus.postest.$model"
                        :label="$t('view.operativos.substatus.form.postest.label')"
                        :error-messages="getFirstErrorDescription($v.substatus.postest)"
                        :items="view.elem.select.postest.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        return-object
                        deletable-chips
                        clearable
                        multiple
                        small-chips
                        :no-data-text="$t('view.commons.nodata')"
                        @input="search = ''" />
                    </v-flex>
                  </v-layout>
                  <!-- ===================================================================================== -->
                  <v-layout row wrap>
                    <!-- Canal Aceptacion -->
                    <v-flex v-if="substatus.payfac">
                      <v-autocomplete
                        v-model.trim="$v.substatus.canalaceptacion.$model"
                        :label="$t('view.operativos.substatus.form.canalaceptacion.label')"
                        :error-messages="getFirstErrorDescription($v.substatus.canalaceptacion)"
                        :items="view.elem.select.canalaceptacion.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        return-object
                        deletable-chips
                        clearable
                        multiple
                        small-chips
                        :no-data-text="$t('view.commons.nodata')"
                        @input="search = ''" />
                    </v-flex>
                  </v-layout>
                  <!-- ===================================================================================== -->
                  <v-layout row wrap>
                    <!-- Clonable -->
                    <v-flex md3 lg2>
                      <label for="substatus" class="v-label mt-3">{{ $t("view.operativos.substatus.form.clonable.label") }}</label>
                      <v-switch v-model="substatus.clonable" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Estatus -->
                    <v-flex md3 lg2>
                      <label for="status" class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                      <v-switch v-model="substatus.status" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>
                  </v-layout>
                </form>
              </v-card-text>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>

      <v-flex v-for="tipo in view.elem.select.tipo.filteredList" :key="tipo.code + '_tipo'" md12>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ tipo.name }}</v-toolbar-title>
            <v-spacer />
            <v-flex xs2 md1>
              <v-switch
                :key="tipo.code + '_tipo'"
                v-model="tipomodel[tipo.code]"
                input-value="true"
                color="primary"
                class="tipo_check mt-0"
                hide-details
                :disabled="view.action.submit.busy"
                @change="changeTipo(tipomodel[tipo.code], tipo.code, tipo.localizacion, tipo.contacto)" />
            </v-flex>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="tipomodel[tipo.code]" :key="tipo.code + '_tipo'" class="py-0">
              <v-card-text>
                <form :key="tipo.code + '_tipo'" @keyup.ctrl.83="executeValidators">
                  <v-layout row wrap>
                    <v-flex v-for="popentry in view.elem.select.popentry.filteredList" :key="tipo.code + '_tipo_' + popentry.code + '_popentry'" xs12 md6>
                      <v-layout row wrap>
                        <!-- Pop Entry -->
                        <v-flex xs3>
                          <v-switch
                            :key="tipo.code + '_tipo_' + popentry.code + '_popentry'"
                            v-model="popentrymodel[tipo.code + '_' + popentry.code]"
                            color="primary"
                            :label="popentry.name"
                            :disabled="view.action.submit.busy"
                            @change="changePopEntry(popentrymodel[tipo.code + '_' + popentry.code], tipo.code + '_' + popentry.code)" />
                        </v-flex>

                        <!-- Pop Exit -->
                        <v-flex xs8>
                          <v-autocomplete
                            :key="tipo.code + '_tipo_' + popentry.code + '_popentry' + '_popexit'"
                            v-model.trim="popexitmodel[tipo.code + '_' + popentry.code]"
                            :label="$t('view.operativos.substatus.form.popexit.label')"
                            :items="popentry.name == 'NO' ? view.elem.select.popexit.filteredList : view.elem.select.popexit.filteredListAlt"
                            :disabled="!popentrymodel[tipo.code + '_' + popentry.code] || view.action.submit.busy"
                            item-value="name"
                            item-text="name"
                            deletable-chips
                            clearable
                            multiple
                            small-chips
                            :no-data-text="$t('view.commons.nodata')"
                            @input="search = ''"
                            @change="changePopExit()">
                            <template #selection="data">
                              <v-chip
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                small
                                :close="!popentry.defaults || !popentry.defaults.includes(data.item.name)"
                                @click:close="removePopExit(data.item, tipo.code + '_' + popentry.code)">
                                {{ data.item.name }}
                              </v-chip>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <!-- Validar Direccion -->
                    <v-flex v-if="tipo.localizacion" md2>
                      <label for="tipo_direccion" class="v-label mt-3">{{ $t("view.operativos.substatus.form.direccion.label") }}</label>
                      <v-switch :key="tipo.code + '_tipo_direccion'" v-model="direccionmodel[tipo.code]" color="primary" :disabled="view.action.submit.busy" @change="changeLocalizacion()" />
                    </v-flex>

                    <!-- Validar Provincia -->
                    <v-flex v-if="tipo.localizacion" md2>
                      <label for="tipo_provincia" class="v-label mt-3">{{ $t("view.operativos.substatus.form.provincia.label") }}</label>
                      <v-switch :key="tipo.code + '_tipo_provincia'" v-model="provinciamodel[tipo.code]" color="primary" :disabled="view.action.submit.busy" @change="changeLocalizacion()" />
                    </v-flex>

                    <!-- Validar Localidad -->
                    <v-flex v-if="tipo.localizacion" md2>
                      <label for="tipo_localidad" class="v-label mt-3">{{ $t("view.operativos.substatus.form.localidad.label") }}</label>
                      <v-switch :key="tipo.code + '_tipo_localidad'" v-model="localidadmodel[tipo.code]" color="primary" :disabled="view.action.submit.busy" @change="changeLocalizacion()" />
                    </v-flex>

                    <!-- Validar Codigo Postal -->
                    <v-flex v-if="tipo.localizacion" md2>
                      <label for="tipo_cp" class="v-label mt-3">{{ $t("view.operativos.substatus.form.codigopostal.label") }}</label>
                      <v-switch :key="tipo.code + '_tipo_cp'" v-model="codigopostalmodel[tipo.code]" color="primary" :disabled="view.action.submit.busy" @change="changeLocalizacion()" />
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <!-- Validar Telefono -->
                    <v-flex v-if="tipo.contacto" md2>
                      <label for="tipo_telefono" class="v-label mt-3">{{ $t("view.operativos.substatus.form.telefono.label") }}</label>
                      <v-switch :key="tipo.code + '_tipo_telefono'" v-model="telefonomodel[tipo.code]" color="primary" :disabled="view.action.submit.busy" @change="changeContacto()" />
                    </v-flex>

                    <!-- Validar Email -->
                    <v-flex v-if="tipo.contacto" md2>
                      <label for="tipo_email" class="v-label mt-3">{{ $t("view.operativos.substatus.form.email.label") }}</label>
                      <v-switch :key="tipo.code + '_tipo_email'" v-model="emailmodel[tipo.code]" color="primary" :disabled="view.action.submit.busy" @change="changeContacto()" />
                    </v-flex>

                    <!-- Validar Whatsapp -->
                    <v-flex v-if="tipo.contacto" md2>
                      <label for="tipo_whatsapp" class="v-label mt-3">{{ $t("view.operativos.substatus.form.whatsapp.label") }}</label>
                      <v-switch :key="tipo.code + '_tipo_whatsapp'" v-model="whatsappmodel[tipo.code]" color="primary" :disabled="view.action.submit.busy" @change="changeContacto()" />
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <!-- Iniciativa -->
                    <v-flex v-if="tipo.adicional" md5>
                      <v-autocomplete
                        v-model.trim="iniciativamodel[tipo.code]"
                        :label="$t('view.operativos.substatus.form.iniciativa.label')"
                        :items="view.elem.select.iniciativa.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="name"
                        item-text="name"
                        hide-selected
                        return-object
                        deletable-chips
                        clearable
                        multiple
                        small-chips
                        :no-data-text="$t('view.commons.nodata')"
                        @change="changeAdicional()"
                        @input="search = ''" />
                    </v-flex>
                  </v-layout>
                </form>
              </v-card-text>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout align-center column class="fab-container">
      <v-btn
        v-if="substatus.clave"
        v-show="$userPermission.hasPermission('ROLE_MODIFICAR_OP')"
        id="btnsubmit"
        fab
        small
        color="primary"
        class="btn_tippy_menu"
        :title="$t('view.commons.update')"
        :loading="view.action.submit.busy"
        :disabled="form.$state.isDisableButtonSubmit()"
        @click="submit()">
        <v-icon small>button__icon icon fas fa-check</v-icon>
      </v-btn>

      <v-btn
        v-show="$userPermission.hasPermission('ROLE_MODIFICAR_OP')"
        id="btnsubmit"
        fab
        small
        color="primary"
        class="btn_tippy_menu"
        :title="$t('view.commons.save')"
        :loading="view.action.submit.busy"
        :disabled="form.$state.isDisableButtonSubmit()"
        @click="submit(true)">
        <v-icon small>button__icon icon fas fa-plus</v-icon>
      </v-btn>

      <v-btn id="btnclear" fab small color="primary" class="btn_tippy_menu" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
        <v-icon small>fa-eraser</v-icon>
      </v-btn>

      <v-btn
        v-show="substatus.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
        id="btnaudit"
        fab
        small
        color="primary"
        class="btn_tippy_menu"
        :title="$t('view.commons.audit')"
        :loading="view.action.submit.busy"
        @click="audit()">
        <v-icon small>storage</v-icon>
      </v-btn>
    </v-layout>

    <auditoria ref="auditModal" />
  </v-container>
</template>
<script>
import subStatusStates from "@/views/operativos/substatus/substatus-state"; /** *******************************/
import subStatusAPI from "@/services/operativos/substatus"; /** *******************************/
import DataTable from "@/views/operativos/substatus/DataTable"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required } from "vuelidate/lib/validators";
import { fixMigImp } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import tippy from "tippy.js";

const select = {
  accion: {
    completeList: []
    , filteredList: []
    , disabled: false
  }
  , statusprecontacto: {
    completeList: []
    , filteredList: []
    , disabled: false
  }
  , tipo: {
    completeList: []
    , filteredList: []
    , disabled: false
  }
  , postest: {
    completeList: []
    , filteredList: []
    , disabled: false
  }
  , canalaceptacion: {
    completeList: []
    , filteredList: []
    , disabled: false
  }
  , popentry: {
    completeList: []
    , filteredList: []
    , disabled: false
  }
  , popexit: {
    completeList: []
    , filteredList: []
    , filteredListAlt: []
    , disabled: false
  }
  , iniciativa: {
    completeList: []
    , filteredList: []
    , filteredListAlt: []
    , disabled: false
  }
};

const action = { submit: { busy: false } };

export default {
  name: "SubstatusModule"
  , components: {
    DataTable
    , Auditoria
  }
  , data() {
    return {
      substatus: undefined
      , tipomodel: {}
      , popentrymodel: {}
      , popexitmodel: {}
      , direccionmodel: {}
      , provinciamodel: {}
      , localidadmodel: {}
      , codigopostalmodel: {}
      , telefonomodel: {}
      , emailmodel: {}
      , whatsappmodel: {}
      , iniciativamodel: {}
      , form: new Object()
      , view: {
        title: this.$t("view.operativos.substatus.title")
        , action
        , elem: {
          select
          , showForm: true
        }
      }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.form = new subStatusStates(this);
    this.form.$setState("initial");
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
      tippy(".btn_tippy_menu", { arrow: true, arrowType: "round", animation: "scale", placement: "left" });
    });
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
      tippy(".btn_tippy_menu", { arrow: true, arrowType: "round", animation: "scale", placement: "left" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit(insert = false) {
      try {
        const respuesta = await this.form.$state.submit(this.substatus, insert);
        if (handleResponse(respuesta, this.$t("view.operativos.substatus.errors"))) {
          this.form.$setState("editing", respuesta.data.results.substatus);
        }
      } catch (error) {
        handleResponse(error, this.$t("view.operativos.substatus.errors"));
      }
    }
    , async load(clave) {
      try {
        this.view.action.submit.busy = true;
        await this.form.$state.loadSelectsData();
        const response = await subStatusAPI.get(clave);
        const { data: { results: { substatus } } } = response;
        this.form.$setState("editing", substatus);
      } catch (error) {
        console.log(error);
        this.view.action.submit.busy = false;
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.substatus.clave, dataDescripcion = this.substatus.descripcion) {
      this.$refs.auditModal.loadAudit(clave, "TSubStatus", dataDescripcion, this.view.title);
    }
    , changeTipo(model, index, localizacion, contacto, adicional) {
      if (!model) {
        Object.keys(this.popentrymodel).forEach((keypentry) => {
          if (keypentry.split("_")[0] == index) {
            this.popentrymodel[keypentry] = false;
            this.popexitmodel[keypentry] = [];
          }
        });
      }

      this.direccionmodel[index] = model ? localizacion : false;
      this.provinciamodel[index] = model ? localizacion : false;
      this.localidadmodel[index] = model ? localizacion : false;
      this.codigopostalmodel[index] = model ? localizacion : false;

      this.telefonomodel[index] = model ? contacto : false;
      this.emailmodel[index] = model ? contacto : false;
      this.whatsappmodel[index] = model ? contacto : false;

      this.iniciativamodel[index] = model ? adicional : null;

      this.setTipoPEE();
    }
    , changePopEntry(model, index) {
      if (!model) {
        this.popexitmodel[index] = [];
      }
      this.setTipoPEE();
    }
    , changePopExit() {
      this.setTipoPEE();
    }
    , changeLocalizacion() {
      this.setTipoPEE();
    }
    , changeContacto() {
      this.setTipoPEE();
    }
    , changeAdicional() {
      this.setTipoPEE();
    }
    , setTipoPEE() {
      let tipopee = [];
      Object.keys(this.tipomodel).forEach((key) => {
        if (this.tipomodel[key]) {
          let tmp = this.view.elem.select.tipo.filteredList.filter((value) => value.code == key)[0];
          let popentrypee = [];
          Object.keys(this.popentrymodel).forEach((keypentry) => {
            if (this.popentrymodel[keypentry] && keypentry.split("_")[0] == key) {
              let tmppentry = this.view.elem.select.popentry.filteredList.filter((value) => value.code == keypentry.split("_")[1])[0];
              if (tmppentry) {
                tmppentry.popexit = this.popexitmodel && this.popexitmodel[keypentry] ? this.popexitmodel[keypentry] : [];
                popentrypee.push(tmppentry);
              }
            }
          });

          tmp.direccion = this.direccionmodel[key];
          tmp.provincia = this.provinciamodel[key];
          tmp.localidad = this.localidadmodel[key];
          tmp.codigopostal = this.codigopostalmodel[key];

          tmp.telefono = this.telefonomodel[key];
          tmp.email = this.emailmodel[key];
          tmp.whatsapp = this.whatsappmodel[key];

          tmp.iniciativa = this.iniciativamodel[key];

          tmp.popentry = popentrypee;

          tipopee.push(JSON.stringify(tmp));
        }
      });
      this.substatus.tipo = tipopee;
    }
    , setSelectsInactiveDataTipo(val, completeList) {
      if (val) {
        const responseList = JSON.parse(val);
        if (responseList && responseList.length > 0) {
          return completeList.filter((value) => {
            if (value.status && value.canales.includes("DEVOLUCIONES")) return value;
            const res = responseList.filter((value1) => value1.code == value.code);
            return res.length > 0 ? res : null;
          });
        }
      }
      return completeList.filter((value) => value.status && value.canales.includes("DEVOLUCIONES"));
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
    , removePopExit(item, keypentry) {
      this.popexitmodel[keypentry].splice(this.popexitmodel[keypentry].indexOf(item.name), 1);
      this.changePopExit();
    }
  }
  , validations: {
    substatus: {
      code: { required }
      , vacio: {}
      , descripcion: { required, fixMigImp: fixMigImp() }
      , accion: {}
      , statusprecontacto: {}
      , postest: {}
      , canalaceptacion: {}
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.substatus .prefix_vacio .v-text-field__prefix {
  width: 50px !important;
  text-align: right;
  padding-right: 4px;
}
.substatus .prefix_vacio .v-label:not(.v-label--active) {
  left: 55px !important;
}
.substatus .v-subheader {
  padding-left: 0;
  font-size: 16px;
  font-weight: bold;
  color: #999;
}
.substatus .v-divider {
  margin: 1.9em 0;
}

.substatus .tipo_check .v-input__slot {
  display: flex;
  justify-content: end;
}

.substatus .fab-container {
  position: fixed;
  bottom: 90px;
  right: 20px;
  z-index: 1;
}
.substatus .fab-container .v-btn {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/substatus/SubStatus.vue